import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {
  MarketSocketService, SOCKET_MSG_TYPES, QUOTE_UPDATE_TYPE, Quote,
  QuoteStoreService, DepthOnlySocketUpdate
} from '@app/_shared/providers';
import { MarketIDMap } from '@app/_shared/shared.enums';
import { Subscription } from 'rxjs';
import { Depth } from './depth.model';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-depth',
  templateUrl: './depth.component.html',
  styleUrls: ['./depth.component.scss']
})
export class DepthComponent implements OnInit, OnDestroy {
  @Input() marketID: string;
  @Input() securityID: number;
  @Input() scripPrecision = 2;

  depth = new Depth();
  quote: Quote;

  private subscriptions = new Subscription();

  constructor(
    private marketSocket: MarketSocketService,
    private quoteStore: QuoteStoreService
  ) { }

  ngOnInit(): void {
    this.sendSubscription();
    this.listenUpdates();

    this.quote = this.quoteStore.getFeedObj(
      MarketIDMap[this.marketID], this.securityID
    );
  }

  sendSubscription() {
    const marketId = MarketIDMap[this.marketID];

    this.marketSocket.subscribeSymbol(
      {market_id:marketId, security_id:this.securityID}
    )

    this.marketSocket.subscribeSymbol({market_id:marketId,security_id: this.securityID}, SOCKET_MSG_TYPES.DAILY_PRICE_RANGE);
  }

  listenUpdates() {
    this.subscriptions.add(
      this.marketSocket.getFeedSubject<DepthOnlySocketUpdate>(QUOTE_UPDATE_TYPE.DEPTH)
        .pipe(
          filter((dep: DepthOnlySocketUpdate) => ((dep.ExchangeId === MarketIDMap[this.marketID]) &&
            (dep.SecurityId === this.securityID))),
          map(dep => dep.depth)
        )
        .subscribe((depth) => {
          this.depth.updateDepth(depth);
        })
    )
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();

    const marketId = MarketIDMap[this.marketID];

   
    this.marketSocket.unSubscribeSymbol({market_id:marketId, security_id:this.securityID}, SOCKET_MSG_TYPES.DAILY_PRICE_RANGE);
  }
}
